import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../cn.js';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  readonly tone?: 'default' | 'sunken' | 'brand';
  readonly padding?: 'none' | 'sm' | 'md';
}

const TONE_CLASSES = {
  default: 'bg-surface border-border',
  sunken: 'bg-surface-sunken border-transparent',
  brand: 'bg-brand-soft border-transparent',
} as const;

const PADDING_CLASSES = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
} as const;

export function Card({
  tone = 'default',
  padding = 'md',
  className,
  children,
  ...rest
}: CardProps): ReactNode {
  return (
    <div
      className={cn(
        'rounded-[var(--r-lg)] border shadow-card',
        TONE_CLASSES[tone],
        PADDING_CLASSES[padding],
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
